import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=55f020cb"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=55f020cb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports